import React from "react";
import { MapPin } from "lucide-react";

const heroImage = "https://media.base44.com/images/public/69e8e257032c3bb17c39059f/f17b717ff_morningboat.jpg";

export default function PremiumYachtHeroVisual({ isRTL = false, openUpgrade, children, unlockLabel = "", imageAlt = "" }) {
  return (
    <div className={`relative flex min-h-[30rem] w-full max-w-full min-w-0 flex-col overflow-hidden rounded-[1.75rem] border border-white/25 bg-ocean text-white shadow-xl shadow-ocean/20 sm:min-h-[32rem] sm:rounded-[2.5rem] md:min-h-[30rem] ${isRTL ? "md:flex-row-reverse" : "md:flex-row"} lg:min-h-[34rem]`}>
      <div className="pointer-events-none absolute -inset-10 bg-primary/10 blur-3xl" />

      {children && (
        <div className="relative z-20 flex w-full max-w-full flex-col justify-center px-4 py-5 sm:px-5 sm:py-6 md:w-1/2 md:px-8 md:py-8 lg:px-10 lg:py-10">
          {children}
        </div>
      )}

      <div className="relative min-h-[18rem] w-full overflow-hidden bg-ocean/40 md:min-h-0 md:w-1/2 md:basis-1/2 md:shrink-0">
        <picture>
          <source media="(min-width: 768px)" srcSet={heroImage} />
          <img
            src={heroImage}
            alt={imageAlt}
            className="absolute inset-0 h-full w-full object-cover object-center brightness-105 contrast-105"
            loading="eager"
            fetchPriority="high"
            decoding="async"
            width="1600"
            height="1000"
            sizes="(min-width: 1024px) 38vw, (min-width: 768px) 48vw, 1px"
          />
        </picture>
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(11,37,69,0.22),transparent_34%),radial-gradient(circle_at_50%_45%,transparent_0%,rgba(2,6,23,0.03)_44%,rgba(2,6,23,0.24)_100%)]" />
        <div className="pointer-events-none absolute inset-0 opacity-50">
          <div className="absolute left-1/4 top-1/4 h-32 w-32 rounded-full bg-white/14 blur-3xl" />
          <div className="absolute right-1/5 top-1/3 h-24 w-24 rounded-full bg-warning/16 blur-2xl" />
          <div className="absolute bottom-0 left-0 h-20 w-full bg-[repeating-linear-gradient(100deg,rgba(255,255,255,.14)_0_1px,transparent_1px_22px)] opacity-25" />
        </div>
        <button
          type="button"
          onClick={openUpgrade}
          className={`absolute bottom-5 z-10 hidden max-w-[17rem] items-center gap-2 rounded-2xl border border-cyan-50/35 bg-ocean/75 px-4 py-2.5 text-xs font-black !text-white shadow-2xl backdrop-blur-xl transition hover:bg-ocean/90 hover:!text-white lg:inline-flex ${isRTL ? "left-5" : "right-5"}`}
        >
          <MapPin className="h-4 w-4 shrink-0 !text-white" /> <span className="truncate !text-white">{unlockLabel}</span>
        </button>
      </div>
    </div>
  );
}